(function(){
    const getCart = function() {
        return fetch('/cart.js').then((res) => res.json())
    }


    function parseUrl(url) {
        if(!url) url = location.search;
        var query = url.substr(1);
        var result = {};
        query.split("&").forEach(function(part) {
          var item = part.split("=");
          result[item[0]] = decodeURIComponent(item[1]);
        });
        return result;
    }

    const updatePageForDiscount = function (code) {
        console.log('Update Page', code);

        let $forms = document.querySelectorAll('form[action="/cart"],form[action="/checkout"]');
        let $checkoutLinks = document.querySelectorAll('a[href^="/checkout"]');

        function createInput() {
            let $input = document.createElement('input');

            $input.type = 'hidden';
            $input.name = 'discount';
            $input.value = 'test';

            console.log('Input?', {$input, code});

            // Mutation Observer
            const config = { attributes: true };

            const callback = function(mutationsList, observer) {
                // Use traditional 'for loops' for IE 11
                console.log('Mutation', mutationsList, $input, $input.value);

                if($input.value !== code) {
                    $input.value = code;
                }

                for(const mutation of mutationsList) {
                    if (mutation.type === 'attributes') {
                        console.log('The ' + mutation.attributeName + ' attribute was modified.');
                    }
                }
            };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe($input, config);

            return $input;
        }

        $checkoutLinks.forEach(function($link) {
            $link.setAttribute('href', `/checkout?discount=${code}`);
        });

        [...$forms].forEach(function($form) {
            $form.prepend(createInput(code));
        });
    }

    const applyDiscounts = async function(discounts) {
        const cart = await getCart();

        const qualifiedDiscounts = [...discounts].filter((discount) => {
            let requirement = discount.cart_requirement;

            switch(requirement) {
                case 'cart_subtotal':
                    console.log('Compare Subtotals', {
                        discount: (discount.subtotal * 100),
                        cart: cart.total_price,
                    });

                    return (discount.subtotal * 100) <= cart.total_price;
                default:
                    return false;
            }

            return false;
        });

        console.log('Qualified Discounts', { cart, qualifiedDiscounts });

        // No Discounts Qualified.
        if(qualifiedDiscounts.length === 0) return;

        // pick the one with the highest required threshold ( should have highest associated discount )
        const highestThreshold = [...qualifiedDiscounts].reduce((highest, discount) => {
            return (discount.subtotal > highest.subtotal) ? discount : highest;
        }, qualifiedDiscounts[0]);


        updatePageForDiscount(highestThreshold.code);

        console.log('Cart and Discounts', { cart, discounts, qualifiedDiscounts, highestThreshold });
    }

    const start = function() {
        let $script = document.querySelector('script[automatic-discounts]');
        const url = parseUrl();

        if(url.discount || url.promocode) {
            let code = url.discount || url.promocode;
            updatePageForDiscount(code);
        }

        console.log('Script?', $script);
        if(!$script) return;

        let data;

        try {
            data = JSON.parse($script.innerHTML);

            applyDiscounts(data);
        } catch (error) {
            console.log('Cant Get Auto Discounts', error);
        }


    }

    window.automatic_discounts_check = start;

    const $cartLinks = document.querySelectorAll('a[href="/cart"], .cart-trigger');
    [...$cartLinks].forEach(function($link) {
        $link.addEventListener('click', start);
    }); 
    start();
})();